// eslint-disable-next-line import/no-cycle
import GDPR from './gdpr';
import views from './views';

class MoveBack {
  constructor(options) {
    this.moveBackBtn = options.moveBackBtn;
    this.type = options.type;
    this.prevPage = options.prevPage;
  }

  render() {
    const { moveBackBtn } = this;
    const { type } = this;
    const { prevPage } = this;

    moveBackBtn.one('tap', (e) => {
      e.preventDefault();

      if (type === 'playful') {
        Pollfish.shortSurveys.present();
        Pollfish.shortSurveys.results();
      } else if (prevPage === 'gdpr') {
        new GDPR({ currentPage: views.common.gdpr }).render();
      } else if (
        prevPage === 'offerwall-surveys' ||
        prevPage === 'unlock-screen' ||
        prevPage === 'offerwall'
      ) {
        if (prevPage === 'offerwall') {
          Pollfish.ui.showOfferwall('offerwall');
          return;
        }
        Pollfish.ui.showOfferwall(prevPage);
      } else if (prevPage === 'offerwall-offers') {
        Pollfish.ui.showOfferwall(prevPage);
      } else if (prevPage === views.common.surveyStartScreen) {
        Pollfish.survey.showOfferwallHomescreen();
      } else {
        Pollfish.helper.initSingleSurvey();
      }
    });
  }
}

export default MoveBack;
